module.exports = __webpack_public_path__ + "img/1F1E8-1F1EE.2ed351a0.svg";